import React from "react"

const Dashboard = () => {
    return <div className="dashboard-fullview overflow-visible"></div>
}

export default Dashboard
